module.exports = __webpack_public_path__ + "assets/90c1629ded2556b3105ae529ebc321a5.png";